"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    LocalePicker: function() {
        return _LocalePicker.LocalePicker;
    },
    LocalePickerOptions: function() {
        return _LocalePickerOptions.LocalePickerOptions;
    }
});
const _LocalePicker = require("./LocalePicker");
const _LocalePickerOptions = require("./LocalePickerOptions");

//# sourceMappingURL=index.js.map